function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var UnStructuredUtil = /*#__PURE__*/function () {
  function UnStructuredUtil() {
    _classCallCheck(this, UnStructuredUtil);
  }
  _createClass(UnStructuredUtil, null, [{
    key: "readContent",
    value: function readContent(fileBlob) {
      return new Promise(function (resolve, reject) {
        if (!fileBlob) {
          resolve([]);
          return;
        }
        var fileReader = new FileReader();
        fileReader.onload = function (event) {
          var _event$target;
          var text = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result; // 从 Blob 中读取的字符串数据
          var data = UnStructuredUtil.handleFileData(text);
          resolve(data);
        };
        fileReader.onerror = function () {
          reject("error");
        };
        fileReader.readAsText(fileBlob);
      });
    }
  }, {
    key: "handleFormatData",
    value: function handleFormatData(fileList) {
      var arr = [];
      fileList.forEach(function (x) {
        var _item;
        var item = {};
        try {
          item = JSON.parse(x);
        } catch (error) {}
        var result = (_item = item) === null || _item === void 0 ? void 0 : _item.text;
        if (item.type === "NarrativeText") {
          var _arr;
          if (((_arr = arr[arr.length - 1]) === null || _arr === void 0 ? void 0 : _arr.type) === "NarrativeText") {
            arr[arr.length - 1].text += " ".concat(result);
          } else {
            arr.push({
              text: result,
              type: "NarrativeText"
            });
          }
        } else if (item.type) {
          arr.push({
            text: result,
            type: item.type
          });
        }
      });
      return arr;
    }
  }, {
    key: "handleFileData",
    value: function handleFileData(text) {
      var fileList = [];
      var t1 = text.split("\n");
      t1.forEach(function (x) {
        if (x) {
          fileList.push(x);
        }
      });
      return this.handleFormatData(fileList);
    }
  }]);
  return UnStructuredUtil;
}();